/**
 * Registry of measured heights for currently-shown CallControls instances.
 * CallBarManager is the sole writer of --call-bar-height; each visible
 * CallControls instance registers/unregisters its own height so that one
 * instance mounting or unmounting never clobbers another's reservation.
 */
type Listener = VoidFunction;

const heights = new Map<string, number>();
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach((listener) => listener());
}

export function registerCallBarHeight(id: string, height: number) {
  heights.set(id, height);
  notify();
}

export function unregisterCallBarHeight(id: string) {
  if (heights.delete(id)) {
    notify();
  }
}

export function getCallBarHeight(): number {
  return heights.size ? Math.max(...heights.values()) : 0;
}

export function subscribeCallBarHeight(listener: Listener): VoidFunction {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Test-only: this registry is a module-level singleton, so a test that
// throws before its component unmounts (or before it calls
// unregisterCallBarHeight directly) would otherwise leak an entry into
// the next test in the same file.
export function __resetCallBarHeightRegistry() {
  heights.clear();
  listeners.clear();
}
